export const DEBOUNCE_DELAY = 200;
export const THROTTLE_DELAY = 33.3;
export const GIFT_SELECTOR = "[data-testid^='mos-item-']";
export const MOS_LINEUP_ID = "mos-lineup";
